module.exports = __webpack_public_path__ + "static/media/muenster.f24fb5c1.jpg";